import React from 'react';
import {createNativeStackNavigator} from '@react-navigation/native-stack';
import {StackParamList} from '../../stacks';
import {SubClientProvider} from '../../../context/sub-client';
import {NotificationsScreen, ProfileScreen} from '../../../screens/internals';
import {
  BalanceDetail,
  BalanceList,
} from '../../../screens/internals/commons/balance';
import {ProofPaymentScreen} from '../../../screens/internals/commons/proof-payment';
import {DashboardScreen} from '../../../screens/internals/sub-client/default/dashboard';
import {
  HistoryDetail,
  HistoryList,
} from '../../../screens/internals/commons/history';
import {PaymentCalculator} from '../../../screens/internals/sub-client/default/calculator';
import {FaqScreen} from '../../../screens/internals/commons/faqs';
import {
  ProofSuccessScreen,
  RemoveSuccessScreen,
  SendSuccessScreen,
} from '../../../screens/internals/commons/success';

const Stack = createNativeStackNavigator<StackParamList>();

type StackGroupAnonymousProps = {
  groupOptions: {
    screenOptions: {headerTransparent: boolean; headerTitle: string};
  };
};

export const NavigatorSubClient = ({
  groupOptions,
}: StackGroupAnonymousProps) => {
  return (
    <SubClientProvider>
      <Stack.Navigator
        initialRouteName={'Dashboard'}
        screenOptions={{headerShown: false}}>
        <Stack.Group {...groupOptions}>
          <Stack.Screen name="Dashboard" component={DashboardScreen} />
          <Stack.Screen name="Profile" component={ProfileScreen} />
          <Stack.Screen name="Notifications" component={NotificationsScreen} />
          <Stack.Screen name="ProofPayment" component={ProofPaymentScreen} />
          <Stack.Screen name="BalanceDetail" component={BalanceDetail} />
          <Stack.Screen name="BalanceList" component={BalanceList} />
          <Stack.Screen name="HistoryDetail" component={HistoryDetail} />
          <Stack.Screen name="HistoryList" component={HistoryList} />
          <Stack.Screen name="Calculator" component={PaymentCalculator} />
          <Stack.Screen name="Faq" component={FaqScreen} />
          <Stack.Screen name="ProofSuccess" component={ProofSuccessScreen} />
          <Stack.Screen name="SendSuccess" component={SendSuccessScreen} />
          <Stack.Screen name="RemoveSuccess" component={RemoveSuccessScreen} />
        </Stack.Group>
      </Stack.Navigator>
    </SubClientProvider>
  );
};
